import { useEffect, useRef } from "react";
import Layout from "../components/Layout";
import { Info } from "@phosphor-icons/react";

const TV_SCRIPT_SRC = "https://s3.tradingview.com/tv.js";
const TV_CONTAINER_ID = "tv-advanced-chart";

function loadTradingViewScript(onLoad) {
  if (window.TradingView) {
    onLoad();
    return;
  }
  let script = document.querySelector(`script[src="${TV_SCRIPT_SRC}"]`);
  if (!script) {
    script = document.createElement("script");
    script.src = TV_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }
  script.addEventListener("load", onLoad, { once: true });
}

function TradingViewMultiChart() {
  const widgetRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    loadTradingViewScript(() => {
      if (cancelled) return;
      widgetRef.current = new window.TradingView.widget({
        symbol: "FX_IDC:USDBRL",
        // O Advanced Chart widget (tv.js) não repassa "precision" ao iframe do
        // chart (não está na whitelist de parâmetros do loader) e ignora esse
        // campo dentro de compareSymbols; a casa decimal de cada símbolo
        // comparado segue o pricescale nativo do provedor e não é configurável
        // por este widget embutido.
        compareSymbols: [
          { symbol: "FX_IDC:EURBRL", position: "NewPriceScale" },
          { symbol: "FX_IDC:USDMXN", position: "NewPriceScale" },
          { symbol: "CAPITALCOM:DXY", position: "NewPriceScale" },
        ],
        // Sem isso, o TradingView balanceia automaticamente as escalas entre
        // esquerda/direita; forçamos tudo à direita (pedido explícito do gerente
        // financeiro para USD/BRL e EUR/BRL ficarem lado a lado).
        overrides: { priceScaleSelectionStrategyName: "right" },
        interval: "D",
        timezone: "America/Sao_Paulo",
        theme: "dark",
        style: "2",
        locale: "br",
        withdateranges: true,
        allow_symbol_change: false,
        autosize: true,
        container_id: TV_CONTAINER_ID,
      });
    });

    return () => {
      cancelled = true;
      widgetRef.current?.remove?.();
      widgetRef.current = null;
    };
  }, []);

  return <div id={TV_CONTAINER_ID} style={{ height: "100%", width: "100%" }} />;
}

export default function Charts() {
  return (
    <Layout>
      <div className="p-6 md:p-8 space-y-4">
        <div>
          <p className="text-[11px] tracking-[0.25em] text-[#6b89a8] uppercase">Mercado · Gráficos</p>
          <h1 className="text-3xl font-bold tracking-tight">Câmbio & Dólar Index</h1>
        </div>

        <div className="border border-[#123a5e] rounded-sm bg-[#0B2D4D] p-4" style={{ height: "calc(100vh - 230px)" }}>
          <TradingViewMultiChart />
        </div>

        <p className="text-xs text-[#6b89a8] flex items-center gap-1.5">
          <Info className="w-3.5 h-3.5 flex-shrink-0" />
          USD/BRL, EUR/BRL, USD/MXN e DXY (Índice do Dólar) sobrepostos no mesmo painel, cada um com eixo próprio à direita e valor real. Dados em tempo real via TradingView.
        </p>
      </div>
    </Layout>
  );
}
